
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/commercial-composting",
      function () {
        return require("private-next-pages/commercial-composting/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/commercial-composting"])
      });
    }
  